module.exports = new Promise((resolve, reject) => {
      // Logic for dynamic resolution in non-dev environments
      const remoteUrl = window.location.origin + '/bulk-uploader/remoteEntry.js';

      if (window['framework_bulk_uploader']) {
          return resolve({
              get: (request) => window['framework_bulk_uploader'].get(request),
              init: (arg) => {
                  try {
                      return window['framework_bulk_uploader'].init(arg);
                  } catch(e) {
                      console.log('Remote container already initialized');
                  }
              }
          });
      }

      const existingScript = document.querySelector(`script[src="${remoteUrl}"]`);
      if (existingScript) {
          existingScript.addEventListener('load', () => {
              resolve({
                  get: (request) => window['framework_bulk_uploader'].get(request),
                  init: (arg) => {
                      try {
                          return window['framework_bulk_uploader'].init(arg);
                      } catch(e) {
                          console.log('Remote container already initialized');
                      }
                  }
              });
          });
          existingScript.addEventListener('error', () => {
              console.warn('Failed to load remote: framework_bulk_uploader from ' + remoteUrl);
              reject(new Error('Failed to load remote: framework_bulk_uploader'));
          });
          return;
      }

      const script = document.createElement('script');
      script.src = remoteUrl;
      script.crossOrigin = 'anonymous';
      script.onload = () => {
          resolve({
              get: (request) => window['framework_bulk_uploader'].get(request),
              init: (arg) => {
                  try {
                      return window['framework_bulk_uploader'].init(arg);
                  } catch(e) {
                      console.log('Remote container already initialized');
                  }
              }
          });
      };
      script.onerror = () => {
          console.warn('Failed to load remote: framework_bulk_uploader from ' + remoteUrl);
          reject(new Error('Failed to load remote: framework_bulk_uploader'));
      };
      document.head.appendChild(script);
  });